import { createSlice } from "@reduxjs/toolkit";
import whiteboardResource from "api/whiteboards/resource";
import whiteboardShareResource from "api/whiteboards/share";
import moment from "moment";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        const res = await whiteboardResource.index(data)
        if (res.data) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.meta.total
            }))
        }

    } catch (err) {
        console.log("err: ", err)
    }
}

export const fetchDataShare = async (data) => {
    try {
        const res = await whiteboardShareResource.index(data)
        if (res.data) {
            res.data.shift()
            store.dispatch(setTableDataShare({
                data: res.data,
                total: res.meta.total
            }))
        }

    } catch (err) {
        console.log("err: ", err)
    }
}

export const fetchDataWhiteboardShare = async (boardId) => {
    try {
        const res = await whiteboardResource.get(boardId)
        if (res.data) {
            store.dispatch(setBoardSharing(res.data))
        }
    } catch (err) {
        console.log("err: ", err)
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    tableDataShare: {
        data: [],
        total: 0,
    },
    boardSharing: {},
    searchQuery: {
        page: 1,
        perPage: 5,
        wb_created_time_start: moment().subtract(1, 'months').startOf('day').valueOf(),
        wb_created_time_end: moment().endOf('day').valueOf(),
        is_wb_moved_to_trash: 0,
        is_my_wb: 1,
        is_wb_share_with_me: 1,
        wb_name: ''
    },
    searchQueryShare: {
        username: ''
    },
    idIsEditing: '',
    isRefresh: false
}

export const managerWhiteboardSlice = createSlice({
    name: 'managerwhiteboard',
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        setTableDataShare: (state, action) => void(state.tableDataShare = action.payload),
        setSearchQueryShare: (state, action) => void (state.searchQueryShare = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
        setIdIsEditing: (state, action) => void(state.idIsEditing = action.payload),
        setBoardSharing: (state, action) => void(state.boardSharing = action.payload)
    }
})

export const { setTableData, setSearchQuery, setTableDataShare, setSearchQueryShare,toggleIsRefresh, setIdIsEditing,setBoardSharing } = managerWhiteboardSlice.actions
export default managerWhiteboardSlice.reducer